import React from 'react';
import './DentalComparisonSection.css';

const DentalComparisonSection = () => {
    // Comparison data structure
    const comparisonData = [
        {
            feature: 'Painless Advanced Treatments',
            wisdom: 'Latest Laser Technology',
            others: 'Traditional, Painful',
        },
        {
            feature: 'Affordable Transparent Pricing',
            wisdom: 'No Hidden Charges',
            others: 'Hidden Costs',
        },
        {
            feature: 'Experienced Dental Experts',
            wisdom: '10+ Years of Experience',
            others: 'Less Experienced',
        },
        {
            feature: 'Sterilization & Hygiene',
            wisdom: 'WHO-Compliant Protocols',
            others: 'Basic Standards',
        },
        {
            feature: 'Fast & Easy Appointments',
            wisdom: 'Same-Day Appointments',
            others: 'Long Waiting Time',
        },
        {
            feature: 'Patient Support & Aftercare',
            wisdom: '24/7 Assistance',
            others: 'Limited Support',
        },
    ];

    // Detect if we're on mobile
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Initial check
        checkIfMobile();

        // Add event listener
        window.addEventListener('resize', checkIfMobile);

        // Cleanup
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    return (
        <div className='comparison-wrapper'>
            <h1 className='comparison-title'>Why Choose Wisdom Dental Clinics Over Other Clinics?</h1>

            {/* Desktop View - Original 3-column layout */}
            <div className='comparison-container'>
                <div className='columns-container'>
                    {/* Features Column - Dark Left Side */}
                    <div className='features-column'>
                        <div className='column-header'>Features</div>
                        {comparisonData.map((row, index) => (
                            <div className='row' key={`feature-${index}`}>
                                <div className='feature-cell'>{row.feature}</div>
                            </div>
                        ))}
                    </div>

                    {/* Wisdom Dental Column - Center */}
                    <div className='wisdom-column'>
                        <div className='column-header'>Wisdom Dental Clinics</div>
                        {comparisonData.map((row, index) => (
                            <div className='row' key={`wisdom-${index}`}>
                                <div className='wisdom-cell'>✅ {row.wisdom}</div>
                            </div>
                        ))}
                    </div>

                    {/* Competitors Column - Right Side */}
                    <div className='others-column'>
                        <div className='column-header'>Other Clinics</div>
                        {comparisonData.map((row, index) => (
                            <div className='row' key={`others-${index}`}>
                                <div className='others-cell'>❌ {row.others}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Mobile View - Grid layout */}
            {isMobile && (
                <div className='mobile-grid-container'>
                    <div className='mobile-content-row'>
                        <div className='mobile-feature'></div>
                        <div className='mobile-header-left'>Wisdom Dental Clinic</div>
                        <div className='mobile-others'>Other Clinics</div>
                    </div>

                    {/* Content rows - feature name, wisdom advantage, competitor disadvantage */}
                    {comparisonData.map((row, index) => (
                        <div className='mobile-content-row' key={`mobile-row-${index}`}>
                            <div className='mobile-feature'>{row.feature}</div>
                            <div className='mobile-wisdom'>
                                <span className='check-icon'>✓</span>
                                {row.wisdom}
                            </div>
                            <div className='mobile-others'>
                                <span className='x-icon'>✗</span>
                                {row.others}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DentalComparisonSection;
